// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PassportActionType from './passport-details.types';
import {
	updatePassportSuccess,
	updatePassportFailure,
	updatePassportResponseChanged,
} from './passport-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { passportUpdate } from './passport-details.service';

/** ***************** Passport Update Start ************************/
export function* updatePassport({ payload }: any) {
	try {
		const key = 'updatePassportID';
		const { companyID, databaseName, memberID, passportImg, proofType, docType, userID } =
			payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			PassportImg: passportImg,
			ProofType: proofType,
			DocumantType: docType,
			OfficerID: userID,
			Secratekey: key,
		};

		const passportData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(passportUpdate, passportData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePassportFailure(responseData.data));
		} else {
			yield put(updatePassportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePassportFailure(error));
	}
}

export function* updatePassportResponseClear() {
	yield put(updatePassportResponseChanged());
}

export function* onPassportUpdateStart() {
	yield takeLatest(PassportActionType.UPDATE_PASSPORT_START, updatePassport);
}

export function* onPassportUpdateResponseRest() {
	yield takeLatest(
		PassportActionType.UPDATE_PASSPORT_RESPONSE_REST_START,
		updatePassportResponseClear,
	);
}
/** ***************** Passport Update End ************************/

export function* passportSaga() {
	yield all([call(onPassportUpdateStart), call(onPassportUpdateResponseRest)]);
}
